/* Add to cart without leaving the page.
   Posts to /cart/add.js, flies the product image into the header cart,
   flashes the button, updates the bubble, then slides the cart drawer out.

   Fourteen things learned the hard way, do not reintroduce them:
   1. No regex literals here. This file is written through an API that passes
      backslashes straight through, and an escaped slash turns the whole file
      into a syntax error, silently letting the native form submit through.
   2. Do NOT dispatch a `cart:update` event. BOTH CartUpdateEvent and
      CartAddEvent use that one name, so a hand-rolled dispatch makes
      CartItemsComponent re-render from its own stale state and wipes the new
      count. We open and refresh the drawer ourselves instead.
   3. Use CSS transitions, not element.animate(). The Web Animations API
      created the flier but never tweened it in the preview browser.
   4. Commit the start styles with a forced reflow (read offsetWidth), NOT
      with a double requestAnimationFrame. The rAF version raced and the
      flier sometimes sat still for its whole life.
   5. Reduced motion SHORTENS the flight, it does not cancel it.
   6. The flight must START somewhere the customer is actually looking. On the
      product page the photo is at the top, so by the time you have scrolled
      to Add to cart it is off-screen above - the chip then animated entirely
      outside the viewport and looked like nothing happened. If the product
      shot is not on screen, launch from the button that was pressed.
   7. The chip SIZE is always measured from the product image, never from the
      fallback launch button. Sizing it off the button made the product page
      chip ~97px while every other button threw a 150px chip, which is why
      the product page animation looked like a different effect.
   8. Refresh the drawer by swapping .cart-drawer__inner only. The <dialog>
      itself has to survive or the component loses the element it opens.
   9. CartDrawerComponent.open() is the preferred way in, but it silently
      no-ops some of the time and so does clicking the header cart button.
      Always verify the dialog actually opened and fall back to the native
      showModal().
  10. Because of 8, STATE CLASSES on the dialog have to be carried across by
      hand. cart-drawer--empty was the one that bit: on the first add of a
      session the page was served with an empty cart, the class stayed behind
      after the swap, and it centres the whole panel and shrinks Check out to
      the width of its label.
  11. Also because of 8, the section's BLOCK STYLESHEETS have to be carried
      across by hand. They come back as <style> tags at the top level of the
      section response, outside cart-drawer-component, so the inner swap
      leaves every one of them behind. It only shows when the page was served
      with an empty cart, because then the summary block never rendered and
      its CSS was never in the page to begin with.
  12. Removing a line used to close the whole drawer. See the guard at the
      foot of this file - do not drop it.
  13. The showModal() fallback in 9 MUST leave the history stack balanced.
      See the note on openDrawer below.
  14. INLINE SCRIPTS IN THE SWAPPED MARKUP DO NOT RUN. Same root cause as 11,
      and it broke the cart's purchase-option toggle. See adoptScripts below,
      including WHICH NODE to read them from -- getting that wrong is a trap
      that looks like it works.

   The flier is the bare product image. The shots are white bottles on white,
   so the soft shadow is what keeps it readable against the bone page. */
(function(){
  if(window.__irrCart)return; window.__irrCart=1;

  var SCOPE='.irr-pf,.irr-uses,.irr-pdp';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = reduce ? 420 : 780;

  function cartTrigger(){
    var b=document.querySelector('.cart-bubble');
    if(b){var p=b.closest('button,a'); if(p)return p;}
    return document.querySelector('header.header-section .header-actions__action');
  }

  function setCount(n){
    document.querySelectorAll('.cart-bubble').forEach(function(b){
      b.classList.toggle('visually-hidden', n < 1);
      var c=b.querySelector('.cart-bubble__text-count');
      if(c){ c.classList.toggle('hidden', n < 1); c.textContent=n; }
    });
  }

  function pulse(el){
    if(!el)return;
    el.style.transition='transform 180ms ease-out';
    el.style.transform='scale(1.45)';
    setTimeout(function(){ el.style.transform='scale(1)';
      setTimeout(function(){ el.style.transition=''; el.style.transform=''; },220); },180);
  }

  function flash(btn,label){
    if(!btn)return;
    var span=btn.querySelector('span')||btn;
    if(!btn.hasAttribute('data-irr-label'))btn.setAttribute('data-irr-label',span.textContent);
    span.textContent=label;
    clearTimeout(btn.__irrT);
    btn.__irrT=setTimeout(function(){
      var o=btn.getAttribute('data-irr-label');
      if(o!==null)span.textContent=o;
      btn.removeAttribute('data-irr-label');
    },1500);
  }

  function onScreen(el){
    if(!el)return false;
    var r=el.getBoundingClientRect();
    var vh=window.innerHeight||document.documentElement.clientHeight;
    var vw=window.innerWidth||document.documentElement.clientWidth;
    if(!r.width||!r.height)return false;
    return r.bottom>40 && r.top<vh-20 && r.right>0 && r.left<vw;
  }

  function sourceImage(form){
    var card=form.closest('.irr-pf__card');
    if(card){ var i=card.querySelector('img'); if(i)return i; }
    var bar=form.closest('.irr-uses__bar');
    if(bar){ var t=bar.querySelector('.irr-uses__thumb'); if(t)return t; }
    var pdp=form.closest('.irr-pdp');
    if(pdp){
      var view=pdp.querySelector('.irr-pdp__view:not([hidden])');
      var m=view&&view.querySelector('.irr-pdp__main');
      if(m)return m;
    }
    var sec=form.closest(SCOPE);
    return sec?sec.querySelector('img'):null;
  }

  /* Where the chip should LAUNCH FROM. Prefer the centre of the product shot,
     exactly as the homepage does. If that is scrolled out of view, use
     whichever add-to-cart control the customer can actually see. This decides
     position only - the size is always taken from the product image so every
     button throws an identical chip. */
  function startPoint(src,form){
    if(onScreen(src)){
      var s=src.getBoundingClientRect();
      return {x:s.left+s.width/2, y:s.top+s.height/2};
    }
    var sec=form.closest(SCOPE);
    var candidates=[];
    if(sec){
      var sticky=sec.querySelector('.irr-pdp__sticky.is-on .irr-pdp__sticky-btn');
      if(sticky)candidates.push(sticky);
    }
    var main=form.querySelector('[name=add]');
    if(main)candidates.push(main);
    for(var i=0;i<candidates.length;i++){
      if(onScreen(candidates[i])){
        var b=candidates[i].getBoundingClientRect();
        return {x:b.left+b.width/2, y:b.top+b.height/2};
      }
    }
    return null;
  }

  function fly(src,target,form,done){
    if(!src||!target){ done(); return; }
    var p=startPoint(src,form), t=target.getBoundingClientRect();
    if(!p||!t.width){ done(); return; }

    /* Measured off the product image even when launching from a button, so
       the chip is the same size on every add-to-cart on the site. */
    var s=src.getBoundingClientRect();
    var size=Math.min(s.width||150, s.height||150, 150);
    if(!(size>0))size=150;

    var cx=p.x-size/2, cy=p.y-size/2;

    var chip=document.createElement('div');
    chip.className='irr-fly';
    chip.style.cssText='position:fixed;left:'+cx+'px;top:'+cy+'px;'+
      'width:'+size+'px;height:'+size+'px;border-radius:14px;overflow:hidden;'+
      'box-shadow:0 14px 34px rgba(26,33,46,.32);'+
      'z-index:2147483647;pointer-events:none;opacity:1;'+
      'transform:translate3d(0,0,0) scale(1);will-change:transform,opacity';

    var img=document.createElement('img');
    img.src=src.currentSrc||src.src;
    img.alt='';
    img.style.cssText='width:100%;height:100%;object-fit:cover;display:block';
    chip.appendChild(img);
    document.body.appendChild(chip);

    var dx=(t.left+t.width/2)-(cx+size/2),
        dy=(t.top+t.height/2)-(cy+size/2);

    var finished=false;
    function end(){ if(finished)return; finished=true;
      if(chip.parentNode)chip.parentNode.removeChild(chip); done(); }
    chip.addEventListener('transitionend',end);

    void chip.offsetWidth; // commit the start styles

    chip.style.transition='transform '+DUR+'ms cubic-bezier(.4,.05,.35,1),'+
      'opacity '+DUR+'ms ease-in,border-radius '+DUR+'ms ease';
    chip.style.transform='translate3d('+dx+'px,'+dy+'px,0) scale(.12)';
    chip.style.opacity='.25';
    chip.style.borderRadius='50%';

    setTimeout(end,DUR+400);
  }

  function refresh(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      setCount(cart.item_count);
      pulse(cartTrigger());
    });
  }

  /* --- Cart drawer -------------------------------------------------------
     CartDrawerComponent exposes open()/close(). Its contents are server
     rendered inside the header section, so after an AJAX add they are stale
     until we re-render them. Swap only .cart-drawer__inner: the <dialog>
     above it is the element the component opens and must survive. */
  function drawerEl(){ return document.querySelector('cart-drawer-component'); }

  function drawerSectionId(el){
    var sec=el&&el.closest('.shopify-section');
    if(!sec||!sec.id)return null;
    var p='shopify-section-';
    return sec.id.indexOf(p)===0 ? sec.id.slice(p.length) : sec.id;
  }

  /* Note 11. Adopt any sheet the page has not already got, keyed on the CSS
     text itself so repeat adds do not pile up duplicates. */
  function adoptStyles(doc){
    if(!window.__irrCartCss)window.__irrCartCss={seen:[]};
    var seen=window.__irrCartCss.seen;

    doc.querySelectorAll('style').forEach(function(s){
      var css=s.textContent||'';
      if(!css)return;
      if(seen.indexOf(css)!==-1)return;
      seen.push(css);
      var tag=document.createElement('style');
      tag.setAttribute('data-irr-cart-css','');
      tag.textContent=css;
      document.head.appendChild(tag);
    });

    var live=document.querySelectorAll('link[rel=stylesheet]');
    doc.querySelectorAll('link[rel=stylesheet]').forEach(function(l){
      var href=l.getAttribute('href');
      if(!href)return;
      for(var i=0;i<live.length;i++){
        if(live[i].getAttribute('href')===href)return;
      }
      var tag=document.createElement('link');
      tag.rel='stylesheet';
      tag.href=href;
      document.head.appendChild(tag);
    });
  }

  /* Note 14. A script inserted through innerHTML / DOMParser NEVER RUNS. The
     browser parses it into the DOM and refuses to execute it, so the swap
     below left the cart's own inline handlers sitting there inert.

     What it broke: the purchase option toggle. Reproduced on a fresh home
     page with an empty cart -- add the 150mL, the drawer opens, and clicking
     Subscribe and save did nothing. Measured at that moment: .irr-cps in the
     DOM, its 9,917 byte handler in the DOM, and window.__irrCps undefined,
     which is the proof it never executed. Only on the FIRST add of a
     session, because a cart served empty never had that markup or that
     script in the page to begin with -- the same trap as note 11.

     READ FROM THE LIVE DRAWER, NOT FROM THE PARSED DOCUMENT. This is the
     part that is easy to get wrong and looks fine: replaceWith() MOVES the
     fresh node out of the parsed document and into the page, so by the time
     this runs, those scripts are no longer in `doc` at all. Passing `doc`
     here injected three unrelated scripts from elsewhere in the response and
     never touched the one that mattered.

     INLINE ONLY, and only real JavaScript. The external module scripts in
     there (component-cart-items.js and friends) are already loaded and their
     custom elements already defined -- quantity and remove were verified
     working without any help. application/ld+json and importmap blocks are
     data, not code, and must not be re-executed.

     Re-running is safe: the cart's handler delegates from document and
     guards itself with window.__irrCps, so a second execution is a no-op.
     The text is remembered anyway so a repeat add never runs it twice. type
     is carried across because that handler is an ES module and needs the
     page's import map to resolve its imports (verified: a dynamically
     inserted module does resolve @theme/* against the page's import map). */
  function adoptScripts(root){
    if(!root)return;
    if(!window.__irrCartJs)window.__irrCartJs={seen:[]};
    var seen=window.__irrCartJs.seen;

    root.querySelectorAll('script').forEach(function(s){
      if(s.src)return;
      var type=s.getAttribute('type');
      var t=(type||'').toLowerCase();
      if(t && t!=='module' && t.indexOf('javascript')===-1)return;
      var code=s.textContent||'';
      if(!code)return;
      if(seen.indexOf(code)!==-1)return;
      seen.push(code);
      var tag=document.createElement('script');
      tag.setAttribute('data-irr-cart-js','');
      if(type)tag.setAttribute('type',type);
      tag.textContent=code;
      document.body.appendChild(tag);
    });
  }

  function refreshDrawer(){
    var d=drawerEl(); if(!d)return Promise.resolve();
    var id=drawerSectionId(d); if(!id)return Promise.resolve();
    return fetch('/?section_id='+encodeURIComponent(id),{headers:{Accept:'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('cart-drawer-component');
        if(!fresh)return;

        /* Styles first, so the new markup is never painted bare. */
        adoptStyles(doc);

        var liveInner=d.querySelector('.cart-drawer__inner');
        var freshInner=fresh.querySelector('.cart-drawer__inner');
        if(liveInner&&freshInner)liveInner.replaceWith(freshInner);

        /* The dialog is deliberately not swapped (note 8), so its state
           classes are whatever the LAST server render left on it. On the
           first add of a session that render was of an empty cart, and the
           leftover cart-drawer--empty centres the panel and shrinks Check
           out to the width of its label. Carry the flag across by hand. */
        var liveDlg=d.querySelector('dialog');
        var freshDlg=fresh.querySelector('dialog');
        if(liveDlg&&freshDlg){
          liveDlg.classList.toggle('cart-drawer--empty',
            freshDlg.classList.contains('cart-drawer--empty'));
        }

        /* Note 14: from the LIVE drawer, after the swap -- the fresh node
           has been moved into it and is no longer inside `doc`. */
        adoptScripts(d);
      })
      .catch(function(){});
  }

  /* Note 13. THE HISTORY STACK HAS TO BALANCE.

     Horizon opens the cart by pushing a history entry, and closes it by
     calling history.back(). That pairs up and the page never moves.

     The showModal() fallback in note 9 broke the pair. When the component's
     own open() silently no-ops we open the dialog natively, which pushes
     nothing -- but the close path still runs history.back(). That back() then
     pops a REAL page entry. Remember the stack depth, and if the component
     neither opened the dialog nor pushed anything, push a throwaway entry of
     our own before showModal() so the close unwinds OURS.

     (Scroll position on close is handled separately, by the one-line
     history.scrollRestoration setting in the GLOBAL CHROME block.) */
  function openDrawer(){
    var d=drawerEl(); if(!d)return;
    var dlg=d.querySelector('dialog');
    var depth=history.length;
    try{ if(typeof d.open==='function')d.open(); }catch(e){}
    /* The component's open() runs the theme's own side effects (history entry,
       sticky summary state) so it is tried first, but it silently does nothing
       often enough that it cannot be trusted on its own. Verify, then use the
       native modal call. */
    setTimeout(function(){
      if(!dlg||dlg.open)return;
      if(history.length===depth){
        try{ history.pushState({irrCart:1},''); }catch(e){}
      }
      try{ dlg.showModal(); }catch(e){}
    },60);
  }

  /* --- Keep the drawer open through a cart change -------------------------
     Note 12. Hitting remove on a line closed the entire drawer, which read as
     the cart vanishing and the page loading. Nothing navigated: the drawer is
     a modal <dialog> over the page, so closing it simply uncovered what was
     already behind.

     DialogComponent dismisses itself on any click it judges to be outside the
     panel, and utilities.js decides that with

       isClickedOutside = (event, element) => !element.contains(event.target)

     Horizon's own onLineItemRemove detaches the row SYNCHRONOUSLY for anyone
     browsing with prefers-reduced-motion set -- the animated path removes it
     on animationend instead, which is why this reproduces for some people and
     not others. The remove button goes with its row, so by the time the click
     finishes bubbling up to cart-drawer-component the target is no longer in
     the document, contains() answers false, and the drawer dismisses itself
     as though the backdrop had been clicked.

     A node that has already left the document cannot mean "clicked outside
     the dialog", so that one case is stopped before the dialog's own listener
     sees it. The test is deliberately this narrow: the close button, Escape
     and a genuine backdrop click all still dismiss, because in every one of
     those the target is still connected.

     Ordering matters and is in our favour. DialogComponent adds its click
     listener inside showDialog(), so it is re-registered on every open, while
     ours is bound once when the element first appears -- ours is always the
     earlier registration on that element and therefore runs first.

     Rebound on cart:update because a section re-render can replace the
     component. Listening to that event is fine; note 2 is about DISPATCHING
     it. */
  function keepDrawerOpen(event){
    var t=event.target;
    if(t&&t.nodeType===1&&!t.isConnected)event.stopImmediatePropagation();
  }

  function guardDrawers(){
    document.querySelectorAll('cart-drawer-component').forEach(function(d){
      if(d.__irrKeptOpen)return;
      d.__irrKeptOpen=1;
      d.addEventListener('click',keepDrawerOpen,false);
    });
  }

  guardDrawers();
  document.addEventListener('DOMContentLoaded',guardDrawers);
  document.addEventListener('cart:update',guardDrawers);

  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form||form.tagName!=='FORM')return;
    var action=form.getAttribute('action')||'';
    if(action.indexOf('/cart/add')===-1)return;
    if(!form.closest(SCOPE))return;

    e.preventDefault();
    var btn=form.querySelector('[name=add]');
    if(btn&&btn.getAttribute('aria-busy')==='true')return;
    if(btn)btn.setAttribute('aria-busy','true');

    flash(btn,'Added');
    var sec=form.closest(SCOPE);
    var sticky=sec&&sec.querySelector('.irr-pdp__sticky.is-on .irr-pdp__sticky-btn');
    if(sticky)flash(sticky,'Added');

    /* The drawer opens when the chip lands AND the add has succeeded, so the
       whole thing reads as one move: chip into the cart, cart slides out. */
    var landed=false, added=false, opened=false;
    function maybeOpen(){
      if(!landed||!added||opened)return;
      opened=true; openDrawer();
    }

    fly(sourceImage(form),cartTrigger(),form,function(){ landed=true; maybeOpen(); });

    fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}})
      .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,body:j}; }); })
      .then(function(res){
        if(!res.ok)throw new Error((res.body&&res.body.description)||'Add to cart failed');
        refresh();
        return refreshDrawer();
      })
      .then(function(){ added=true; maybeOpen(); })
      .catch(function(err){
        console.warn('[irr-cart]',err&&err.message);
        if(btn&&btn.hasAttribute('data-irr-label')){
          var sp=btn.querySelector('span')||btn;
          sp.textContent=btn.getAttribute('data-irr-label');
          btn.removeAttribute('data-irr-label');
        }
      })
      .then(function(){ if(btn)btn.removeAttribute('aria-busy'); });
  },true);
})();
